var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealEstate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5352 39C23.5352 37.9 22.6352 37 21.5352 37V41C22.6352 41 23.5352 40.1 23.5352 39Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5352 13L11.5352 26.1V55C11.5352 56.1 12.4352 57 13.5352 57H49.5352C50.6352 57 51.5352 56.1 51.5352 55V26.1L31.5352 13ZM15.5352 33C15.5352 30.8 17.3352 29 19.5352 29V27H21.5352V29C23.7352 29 25.5352 30.8 25.5352 33H23.5352C23.5352 31.9 22.6352 31 21.5352 31V35C23.7352 35 25.5352 36.8 25.5352 39C25.5352 41.2 23.7352 43 21.5352 43V45H19.5352V43C17.3352 43 15.5352 41.2 15.5352 39H17.5352C17.5352 40.1 18.4352 41 19.5352 41V37C17.3352 37 15.5352 35.2 15.5352 33ZM47.5352 53H15.5352V51H47.5352V53ZM47.5352 49H15.5352V47H47.5352V49ZM47.5352 45H27.5352V43H47.5352V45ZM47.5352 41H27.5352V39H47.5352V41ZM47.5352 37H27.5352V35H47.5352V37ZM47.5352 33H27.5352V31H47.5352V33ZM47.5352 29H27.5352V27H47.5352V29Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5352 31C18.4352 31 17.5352 31.9 17.5352 33C17.5352 34.1 18.4352 35 19.5352 35V31Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8364 22L33.1364 4.5C32.7364 4.2 32.1364 4 31.5364 4C30.9364 4 30.3364 4.2 29.9364 4.5L3.33636 21.9C1.93636 22.9 1.63636 24.6 2.43636 26C3.03636 26.9 3.93636 27.4 4.93636 27.4C5.53636 27.4 6.13636 27.2 6.63636 26.9L31.5364 10.6L56.4364 26.9C56.9364 27.2 57.5364 27.4 58.1364 27.4C59.1364 27.4 60.1364 26.9 60.6364 26C61.5364 24.7 61.1364 22.9 59.8364 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstate);
export default __webpack_public_path__ + "static/media/Real Estate.b6590c1ed9dbd2287442f956f18f8113.svg";
export { ForwardRef as ReactComponent };